<template>
   <div class="fullpage"  id="contattifullpage"  >
      <div class="headline" >
            <div>{{ dicosahaibisognolabel }}</div>
            <div>{{ siamoquipertelabel }}</div>
            <div class="email_contatti"><a :href="company_mailto">{{company_email}}</a></div>
            <div class="telefono_contatti">{{ company_tel }}</div>
            <div class="dove_contatti"  ><a :href="linkmappa">{{ simadovelabel }}</a></div>
      </div>
      
      <div class="arrow_down"><a :href="linkmappa"><img src="@/assets/images/arrow_down_white.svg"></a></div>

   </div> 
   
</template>

<script>

import multilangmixin from "../mixins/multilangmixin.js"
import companymixin from "../mixins/companymixin.js"




export default {
  name: "cmpcontatti",
  mixins:[multilangmixin,companymixin],
  props:["linkmappa"],
  
  data(){
      return {

             
              
            };
  },


  created(){
    //console.log("created ",this.$options.name, "   lingua: ",this.currentlang);

  },

  computed:{
      
       
 
      linkcasestudies()
      {
        return "/"+this.currentlang+"/casestudies";
      },

      dicosahaibisognolabel(){
        return this.fnGetTranslation(this.currentlang,"dicosahaibisogno");
      },
      siamoquipertelabel(){
        return this.fnGetTranslation(this.currentlang,"siamoquiperte");
      },
      simadovelabel(){
        return this.fnGetTranslation(this.currentlang,"simadove");
      }
      

  },


  methods:{
 

  }

  

}


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    
  .email_contatti{
    margin-top: 2vh;    
    
    color: white;        
    font-weight: 600;
  }


  .email_contatti a 
  {
    color: white; 
    text-decoration: none;
    font-weight: 600;
  }

  .email_contatti  a:visited{
    color: white;
    text-decoration: none;
    font-weight: 600;
  }

  .email_contatti a:active{
    color: white;
    text-decoration: none;
    font-weight: 600;
  }

  .email_contatti a:hover{
  font-weight: 600;
  color: white;
  font-weight: bold;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: white;
  text-decoration-thickness: 0.2em;
  }

 
.dove_contatti{
    margin-top: 3vh;    
    
    color: black;        
    font-weight: bold;
  }


  .dove_contatti a 
  {
    color: black; 
    text-decoration: none;
    font-weight: 600;
  }

  .dove_contatti  a:visited{
    color: black;
    text-decoration: none;
    font-weight: 600;
  }

  .dove_contatti a:active{
    color: black;
    text-decoration: none;
    font-weight: 600;
  }

  .dove_contatti a:hover{
  font-weight: 600;
  color: black;
  font-weight: bold;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: black;
  text-decoration-thickness: 0.2em;
  }





  .telefono_contatti{
    color: white;    
    font-weight: 600;  
  }


 .fullpagecontatti{

   background-color: #ffdd00;
   width: 100vw;
   height: 94vh;
   transition: 0.7s;
   color: black;
   position: relative;
   /* margin-top: 20vh;*/
 }

 
 .withopacity{
   color: #00000025;
   transition: 0.7s;

 }


.sottolineato{

    
    text-decoration: underline;
    text-decoration-style: solid;
    /*text-decoration-color: #ffdd00;*/
    
    text-decoration-thickness: 0.1em;    
    /* line-height: 7vh; */
    /* text-underline-offset: 1vh;*/


}
     




.activelink
{
    color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    

}
 
.activelink:visited{

  color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.activelink:active{

  color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.activelink:hover{

    color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}






.normallink
{
    color: black; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    

}
 
.normallink:visited{

  color: black; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.normallink:active{

  color: black; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

.normallink:hover{

    color: white; 
    text-decoration: underline;
    text-decoration-color: white;
    text-decoration-style: solid;
    text-decoration-thickness: 0.2em;    
}

 


  @media screen and (min-width: 600px)    {
      /*  schermo desktop */
    
      .headline
      {
        
        margin-left: auto;
        margin-right: auto;
        
        max-width: 60%;
        min-height: 200px;
        font-weight: 800;
        font-size: 3vw;
        /*padding-top: 30px;
        padding-left: 80px;
        */
        border-width: 0px;
        padding-top: 27vh;   


       

      }
    

      .dove_contatti{
          font-size: 2vw;
        }

      .arrow_down{
        position: absolute;
        right: 5vh;
        bottom: 5vh;
        
      }


      


  }
  
  @media screen and (max-width: 600px) {
     /*  schermo mobile */
  

  
    .headline
    {
      max-width: 80%;
       margin-left: auto;
        margin-right: auto;
      /*padding-top: 30px;
      padding-left: 20px;*/
        padding-top: 20vh;    
      
      min-height: 200px;
      font-weight: 800;
      
      font-size: 5vw;

      line-height: 3.5vh;

     

    }




    .arrow_down{
      position: absolute;
      right: 5vh;
      bottom: 20vh;
      
    }


    .arrow_down a img{
        width: 10vw;    
    }


     .dove_contatti{
          font-size: 4vw;
        }

  }


</style>
